export const MODAL_TYPES = {
  OK_MODAL: 'OK_MODAL',
  YES_NO_MODAL: 'YES_NO_MODAL',
  EMAIL_CONFIRMATION_MODAL: 'EMAIL_CONFIRMATION_MODAL',
  RENAME_MODAL: 'RENAME_MODAL',
  REJECT_MODAL: 'REJECT_MODAL',
};
